export default __webpack_public_path__ + "static/media/ppt.629e873e.svg";